"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
const useStyles = props => {
  const {
    width
  } = props;
  const {
    getMeasurement
  } = (0, _hooks.useStylesUtils)();
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const ccCarrouselStyle = (0, _react.useMemo)(() => {
    const mobileProps = () => {
      if (isMobileView) {
        return {
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        };
      }
      return {};
    };
    const ccCarrousel = (0, _css.css)({
      margin: '0 auto',
      width: width ? getMeasurement(width) : 'fit-content',
      height: 'auto',
      position: 'relative',
      overflow: 'hidden',
      transition: 'width 0s ease-in-next, height 0s ease-in-next'
    });
    const ccCarrouselCurrentItem = (0, _css.css)({
      position: 'relative',
      width: width ? getMeasurement(width) : 'auto',
      ...mobileProps()
    });
    const ccCarrouselSwappedItem = (0, _css.css)({
      pointerEvents: 'none',
      width: width ? getMeasurement(width) : 'auto',
      position: 'absolute',
      top: 0,
      transition: 'opacity .5s ease-in-out, right .5s ease-in-out, left .5s ease-in-out'
    });
    return {
      ccCarrousel,
      ccCarrouselCurrentItem,
      ccCarrouselSwappedItem
    };
  }, [getMeasurement, isMobileView, width]);
  return {
    'cc-Carrousel': ccCarrouselStyle.ccCarrousel,
    'cc-Carrousel__current-item': ccCarrouselStyle.ccCarrouselCurrentItem,
    'cc-Carrousel__swapped-item': ccCarrouselStyle.ccCarrouselSwappedItem
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;